import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, map, tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {AccountEntriesAppliedEvent} from '@shared/application/events/account/account-entries-applied.event';
import {CartTotalChangedEvent} from '@platform/event-bus/domain/events/cart/cart-total-changed.event';

@Injectable({providedIn: 'root'})
export class PlatformOnAccountEntriesAppliedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);

  constructor() {
    this.eventBus
      .ofType(AccountEntriesAppliedEvent)
      .pipe(
        map(event => event.account.entriesTotal),
        filter((total): total is number => typeof total === 'number'),
        tap(total =>
          this.eventBus.publish(
            new CartTotalChangedEvent({newTotal: total}),
          ),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
